import jwt_decode from 'jwt-decode';

export const TOKEN_KEY = '@User:token';
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);


export const isTokenExpired = () => {
  const token = getToken();
  if (!token) {
    return null;
  }

  const decoded = jwt_decode(getToken());

  var tokenExpiry = decoded.exp * 1000;

  return new Date() > tokenExpiry;
};

export const login = token => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = () => {
  localStorage.clear();
};

export const setLocal = (name, value) => {
  localStorage.setItem(`${name}Key`, value);
};

export const getLocal = (name, value) => {
  return localStorage.getItem(`${name}Key`);
};
